<template lang="">
  <div class="w-full h-80">
    <img
      src="../assets/hero.jpg"
      alt="Dog Image"
      class="object-cover object-top w-full h-full "
    />
  </div>
</template>
<script>
  export default {};
</script>
